import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/front/eva-ai-web/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/builds/front/eva-ai-web/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/builds/front/eva-ai-web/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/builds/front/eva-ai-web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/builds/front/eva-ai-web/public/img/joi.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["PromoEventButton"] */ "/builds/front/eva-ai-web/src/features/promoEvent/ui/PromoEventButton/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StorageScopeInitializer"] */ "/builds/front/eva-ai-web/src/features/storage/ui/StorageScopeInitializer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/builds/front/eva-ai-web/src/features/toaster/Toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BotWizard"] */ "/builds/front/eva-ai-web/src/widgets/BotWizard/index.tsx");
